/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiPriorityWaitTimesFromJSON, StreemApiPriorityWaitTimesToJSON, } from './';
export function StreemApiEventsGroupWaitTimeUpdatedFromJSON(json) {
    return StreemApiEventsGroupWaitTimeUpdatedFromJSONTyped(json, false);
}
export function StreemApiEventsGroupWaitTimeUpdatedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'groupSid': !exists(json, 'group_sid') ? undefined : json['group_sid'],
        'groupName': !exists(json, 'group_name') ? undefined : json['group_name'],
        'priorityWaitTimes': !exists(json, 'priority_wait_times') ? undefined : StreemApiPriorityWaitTimesFromJSON(json['priority_wait_times']),
    };
}
export function StreemApiEventsGroupWaitTimeUpdatedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company_sid': value.companySid,
        'group_sid': value.groupSid,
        'group_name': value.groupName,
        'priority_wait_times': StreemApiPriorityWaitTimesToJSON(value.priorityWaitTimes),
    };
}
//# sourceMappingURL=StreemApiEventsGroupWaitTimeUpdated.js.map